'use client';

import type { ForwardedRef } from 'react';
import { FileTrigger as RACFileTrigger, type FileTriggerProps as RACFileTriggerProps } from 'react-aria-components';
import { forwardRef } from '../forward-ref.js';

export interface FileTriggerProps extends Pick<
  RACFileTriggerProps,
  'acceptedFileTypes' | 'allowsMultiple' | 'defaultCamera' | 'onSelect' | 'children' | 'acceptDirectory'
> {}

/**
 * Allows a user to access the file system with any pressable Cimpress UI component.
 *
 * See [file trigger API documentation](https://ui.cimpress.io/components/file-trigger/api).
 */
function FileTrigger(props: FileTriggerProps, ref: ForwardedRef<HTMLInputElement>) {
  return <RACFileTrigger {...props} ref={ref} />;
}

const _FileTrigger = forwardRef(FileTrigger, 'FileTrigger');

export { _FileTrigger as FileTrigger };
